// Cloudflare Turnstile check for the sign-in forms: the staff ones (CMS admin and super console, #228) and the online
// store's customer sign-up and sign-in. Unlike the contact form's check, a missing secret only passes in local dev:
// anywhere else sign-in is refused until it is configured.

const SITEVERIFY = 'https://challenges.cloudflare.com/turnstile/v0/siteverify'

/** The widget's `action` on both sign-in forms; a token made for another form on the same widget is refused. */
export const LOGIN_CAPTCHA_ACTION = 'login'

/** Cloudflare's test secrets (always pass / always fail / token spent): they answer without the real action. */
const TEST_SECRET = /^[123]x0{30,}AA$/

export type LoginCaptchaVerdict = 'ok' | 'failed' | 'not_configured'

/** `action` is the widget's action the token must carry; the staff forms use LOGIN_CAPTCHA_ACTION. */
export async function checkLoginCaptcha(input: { secret: string | undefined; token: string | undefined; ip: string | null; environment: string; action?: string }): Promise<LoginCaptchaVerdict> {
  if (!input.secret) return input.environment === 'local' ? 'ok' : 'not_configured'
  if (!input.token) return 'failed'
  const body = new FormData()
  body.set('secret', input.secret)
  body.set('response', input.token)
  if (input.ip) body.set('remoteip', input.ip)
  try {
    const res = await fetch(SITEVERIFY, { method: 'POST', body })
    if (!res.ok) return 'failed'
    const data = (await res.json()) as { success?: boolean; action?: string }
    if (data.success !== true) return 'failed'
    return TEST_SECRET.test(input.secret) || data.action === (input.action ?? LOGIN_CAPTCHA_ACTION) ? 'ok' : 'failed'
  } catch {
    return 'failed'
  }
}
